// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2TdXu{display:inline-block;text-align:center}._3unZh,._1uAY-{display:block;font-size:60%}._28UPM{border-top:1px solid #000;display:block;margin:2px 0}", ""]);
// Exports
exports.locals = {
	"fraction": "_2TdXu",
	"fraction__denominator": "_3unZh",
	"fraction__numerator": "_1uAY-",
	"fraction__bar": "_28UPM"
};
module.exports = exports;
